import { render, staticRenderFns } from "./SDSFilter.vue?vue&type=template&id=1d2c5cfa&scoped=true"
import script from "./SDSFilter.vue?vue&type=script&lang=js"
export * from "./SDSFilter.vue?vue&type=script&lang=js"
import style0 from "./SDSFilter.vue?vue&type=style&index=0&id=1d2c5cfa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c5cfa",
  null
  
)

export default component.exports